<template>
  <div>
    <div v-if="show" class="dialog-add-account__form-title">
      {{ $t('business_account_data.automatization') }}
    </div>
    <div v-if="show" class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
          <!-- label 1C -->
          <label class="input__item-checkbox">
            <input type="checkbox" value="'all'" v-model="autoActsValue" :disabled="disabled" />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span class="input__item-checkbox__title" v-html="$t('business_account_data.auto1c')">
              </span>
            </span>
          </label>
          <!-- AutocashBack -->
          <label class="input__item-checkbox">
            <input type="checkbox" value="'all'" v-model="autoCashbackValue" :disabled="disabled" />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span
                class="input__item-checkbox__title"
                v-html="$t('business_account_data.auto_cashback')"
              >
              </span>
            </span>
          </label>
          <label class="input__item-checkbox">
            <input type="checkbox" value="'all'" v-model="accessApiValue" :disabled="disabled" />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span
                class="input__item-checkbox__title"
                v-html="$t('business_account_data.access_to_api')"
              >
              </span>
            </span>
          </label>
          <!-- Принудительный выбор бонусов -->
          <label class="input__item-checkbox">
            <input type="checkbox" value="'all'" v-model="isForceBonusValue" :disabled="disabled" />
            <span class="input__item-checkbox__check">
              <img src="@/assets/icons/icon-done.svg" />
            </span>
            <span class="input__item-checkbox__info">
              <span
                class="input__item-checkbox__title"
                v-html="$t('business_account_data.force_bonus_selection')"
              >
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutomationSettings',
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          'auto_acts' in value &&
          'auto_cashback' in value &&
          'access_api' in value &&
          'is_force_bonus' in value
        );
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    autoActsValue: {
      get() {
        return this.value.auto_acts ? ["'all'"] : [];
      },
      set(newVal) {
        // newVal может быть массивом ["'all'"] или []
        const isChecked = Array.isArray(newVal) ? newVal.includes("'all'") : newVal === "'all'";
        this.$emit('update:auto_acts', isChecked);
      },
    },
    autoCashbackValue: {
      get() {
        return this.value.auto_cashback ? ["'all'"] : [];
      },
      set(newVal) {
        // newVal может быть массивом ["'all'"] или []
        const isChecked = Array.isArray(newVal) ? newVal.includes("'all'") : newVal === "'all'";
        this.$emit('update:auto_cashback', isChecked);
      },
    },
    accessApiValue: {
      get() {
        return this.value.access_api ? ["'all'"] : [];
      },
      set(newVal) {
        // newVal может быть массивом ["'all'"] или []
        const isChecked = Array.isArray(newVal) ? newVal.includes("'all'") : newVal === "'all'";
        this.$emit('update:access_api', isChecked);
      },
    },
    isForceBonusValue: {
      get() {
        const val = this.value.is_force_bonus !== undefined ? this.value.is_force_bonus : true;
        return val ? ["'all'"] : [];
      },
      set(newVal) {
        // newVal может быть массивом ["'all'"] или []
        const isChecked = Array.isArray(newVal) ? newVal.includes("'all'") : newVal === "'all'";
        this.$emit('update:is_force_bonus', isChecked);
      },
    },
  },
  emits: ['update:auto_acts', 'update:auto_cashback', 'update:access_api', 'update:is_force_bonus'],
};
</script>
